import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

type ToolCard = {
  path: string;
  title: string;
  description: string;
  badge?: string;
};

@Component({
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  protected readonly tools: ToolCard[] = [
    {
      path: '/validate',
      title: 'Validate filing',
      description: 'Validate a .zip or CSV report package, or legacy XML filing, against EBA RF 4.2.',
      badge: 'Beta',
    },
    {
      path: '/reports',
      title: 'Report viewer',
      description: 'Upload .zip, .xbrl, or CSV package — preview report data and export Excel.',
      badge: 'Beta',
    },
    {
      path: '/compare',
      title: 'Compare filings',
      description: 'Diff two filings and export only the differences.',
      badge: 'Beta',
    },
    {
      path: '/trend',
      title: 'Period comparison',
      description: 'Compare metrics across multiple reporting periods.',
      badge: 'Beta',
    },
    {
      path: '/build',
      title: 'Build report package',
      description: 'Download the Excel template, fill report data, generate an xBRL-CSV package.',
      badge: 'Beta',
    },
    {
      path: '/dev',
      title: 'Developer',
      description: 'Spike lab with bundled sample filings — no upload required.',
      badge: 'Beta',
    },
  ];
}
